module.exports = __webpack_public_path__ + "media/images/icons/material/flag-268af805faf65401ba8744df31d620a0.svg";